
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/characters/[slug]/more-like-actor/[actorId]",
      function () {
        return require("private-next-pages/characters/[slug]/more-like-actor/[actorId]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/characters/[slug]/more-like-actor/[actorId]"])
      });
    }
  